import { capitalizeFirstLetter } from "../../../../../utils/string";
import BoldTableCell from "../../../general/table/BoldTableCell";
import TeacherPortalLearningMaterialModal from "../../../learning_materials/learning_material/LearningMaterialModal";
import React from "react";

const TeacherPortalStudentLearningMaterialInformationTab = ({ student, activities, activitiesWithUsageData }) => {
    const [learningMaterialModalId, setLearningMaterialModalId] = React.useState(undefined)
    const [hoveringOnActivityId, setHoveringOnActivityId] = React.useState(undefined)

    student = {

        ...student, "use_data": student.use_data.map((useData) => {
            const activity = activities.find((activity) =>
                activity.activityid === useData.activityid)
            useData.activitytitle = activity.activitytitle
            return useData
        })
    }
    const sortedUseData = student.use_data.sort((a, b) => {
        // Sort by activitytitle
        const aTitle = a.activitytitle.toLowerCase();
        const bTitle = b.activitytitle.toLowerCase();
        if (aTitle < bTitle) {
            return -1;
        }
        if (aTitle > bTitle) {
            return 1;
        }
        return 0;
    })
    if (sortedUseData.length === 0) {
        return <p>This student has not used any learning materials yet.</p>
    }
    else {
        return <>
            {learningMaterialModalId !== undefined &&
                <TeacherPortalLearningMaterialModal activityWithUsageData={activitiesWithUsageData.find((activityWithUsageData) => activityWithUsageData.activityid == learningMaterialModalId)} onClose={() => setLearningMaterialModalId(undefined)} />
            }
            <table className="w-full border-collapse">
                <thead>
                    <tr>
                        <BoldTableCell>
                            Learning Material
                        </BoldTableCell>
                        <BoldTableCell>
                            First Accessed
                        </BoldTableCell>
                        <BoldTableCell>
                            Last Accessed
                        </BoldTableCell>
                        <BoldTableCell>
                            Number of actions performed
                        </BoldTableCell>
                        <BoldTableCell>
                            Actions performed
                        </BoldTableCell>
                    </tr>
                </thead>
                <tbody onMouseLeave={() => setHoveringOnActivityId(undefined)}>
                    {sortedUseData.map((activityUseData, index) => {
                        return <tr className={"cursor-pointer " + (hoveringOnActivityId === activityUseData.activityid ? "bg-card_dark" : "bg-white")}
                            onClick={() => setLearningMaterialModalId(activityUseData.activityid)} onMouseOver={() => setHoveringOnActivityId(activityUseData.activityid)}>
                            <td className="p-4 border-b border-black/10">
                                {activityUseData.activitytitle}
                            </td>
                            <td className="p-4 border-b border-black/10">
                                {activityUseData.min_timestamp}
                            </td>
                            <td className="p-4 border-b border-black/10">
                                {activityUseData.max_timestamp}
                            </td>
                            <td className="p-4 border-b border-black/10">
                                {activityUseData.count_events}
                            </td>
                            <td className="p-4 border-b border-black/10">
                                {activityUseData.verbs.map(capitalizeFirstLetter).join(", ")}
                            </td>
                        </tr>

                    })}
                </tbody>
            </table>
        </>
    }
}


export default TeacherPortalStudentLearningMaterialInformationTab